export const safeSteps = [
  {
    title: "先想清楚要说的核心事实",
    desc: "不需要写成完整报道。把「发生了什么、发生在哪里、大概什么时候、你怎么知道的」这四件事讲清楚，就已经足够有用了。",
  },
  {
    title: "把身份线索留在心里",
    desc: "正文里不要出现你的工号、部门、直属上级的称呼组合、只有你参与过的会议记录等。这些细节叠加起来最容易被反查。",
  },
  {
    title: "用分离的设备与网络环境提交",
    desc: "尽量使用与日常工作、生活账号无关的设备和网络。不要在投稿前后短时间内频繁切换回你的常用账号。",
  },
  {
    title: "需要回执时只留代号",
    desc: "如果想收到反馈，填一个只有你自己看得懂的代号即可。我们不会通过代号反过来追问你的真实身份。",
  },
];

export const safetyTips = [
  "不要在投稿中同时出现你的职位、部门、入职时间等组合信息",
  "上传材料前，先去掉文件属性中的拍摄或创建信息",
  "避免使用单位统一配发的邮箱或内网账号进行任何沟通",
  "不要向第三方转发你已提交的同一份内容",
  "如非必要，不要提供可以反向定位到值班表的精确时间",
  "投稿后一段时间内，保持与原常用账号的行为习惯不变",
];

export const acceptedItems = [
  "有明确时间、地点或对象的具体事实描述",
  "能够指向可公开查证的记录或文件类型",
  "涉及公共利益、消费者权益或公共安全的问题",
  "由你亲身经历或直接了解、可以复述细节的情况",
];

export const rejectedItems = [
  "只有情绪表达、没有事实指向的内容",
  "与公共利益无关的私人纠纷或他人隐私",
  "无法核实、来源不明的传闻与转述",
  "带有明显商业诋毁或恶意竞争目的的内容",
];

export const guideFaqs = [
  {
    question: "投稿正文写多长比较合适？",
    answer:
      "建议控制在 200 到 500 字之间，把关键事实讲清楚即可。单次投稿上限为 500 字，如果内容较多，可以分次提交或先提交核心部分。",
  },
  {
    question: "可以用手机直接提交吗？",
    answer:
      "可以，但更建议在你自己信任的设备上操作。如果条件允许，使用与日常账号分离的网络环境会更稳妥。",
  },
  {
    question: "投稿后需要我持续跟进吗？",
    answer:
      "不需要。你可以随时停止参与。只有在你自己愿意留下回执代号的情况下，我们才会与你保持匿名联系。",
  },
];